import Icon from 'ms-ui-primitives/Icon';

import type { Props } from '../types';

const DifficultyMedium = ({
  color,
  size,
  title,
  titleId,
  aphroditeStyles = [],
}: Props) => (
  <Icon
    color="none"
    size={size}
    aphroditeStyles={aphroditeStyles}
    title={title}
    titleId={titleId}
    viewBoxWidth={20}
    viewBoxHeight={20}
  >
    <mask
      id="mask0_1348_20594"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="1"
      y="3"
      width="18"
      height="14"
    >
      <mask id="path-1-inside-1_1348_20594" fill="white">
        <path d="M1.6665 11.6663C1.6665 10.7459 2.4127 9.99967 3.33317 9.99967H4.99984C5.92031 9.99967 6.6665 10.7459 6.6665 11.6663V14.9997C6.6665 15.9201 5.92031 16.6663 4.99984 16.6663H3.33317C2.4127 16.6663 1.6665 15.9201 1.6665 14.9997V11.6663Z" />
        <path d="M7.49984 8.33301C7.49984 7.41253 8.24603 6.66634 9.1665 6.66634H10.8332C11.7536 6.66634 12.4998 7.41253 12.4998 8.33301V14.9997C12.4998 15.9201 11.7536 16.6663 10.8332 16.6663H9.1665C8.24603 16.6663 7.49984 15.9201 7.49984 14.9997V8.33301Z" />
        <path d="M13.3332 4.99967C13.3332 4.0792 14.0794 3.33301 14.9998 3.33301H16.6665C17.587 3.33301 18.3332 4.0792 18.3332 4.99967V14.9997C18.3332 15.9201 17.587 16.6663 16.6665 16.6663H14.9998C14.0794 16.6663 13.3332 15.9201 13.3332 14.9997V4.99967Z" />
      </mask>
      <path
        d="M1.6665 11.6663C1.6665 10.7459 2.4127 9.99967 3.33317 9.99967H4.99984C5.92031 9.99967 6.6665 10.7459 6.6665 11.6663V14.9997C6.6665 15.9201 5.92031 16.6663 4.99984 16.6663H3.33317C2.4127 16.6663 1.6665 15.9201 1.6665 14.9997V11.6663Z"
        fill="black"
      />
      <path
        d="M7.49984 8.33301C7.49984 7.41253 8.24603 6.66634 9.1665 6.66634H10.8332C11.7536 6.66634 12.4998 7.41253 12.4998 8.33301V14.9997C12.4998 15.9201 11.7536 16.6663 10.8332 16.6663H9.1665C8.24603 16.6663 7.49984 15.9201 7.49984 14.9997V8.33301Z"
        fill="black"
      />
      <path
        d="M1.6665 11.6663C1.6665 10.7459 2.4127 9.99967 3.33317 9.99967H4.99984C5.92031 9.99967 6.6665 10.7459 6.6665 11.6663V14.9997C6.6665 15.9201 5.92031 16.6663 4.99984 16.6663H3.33317C2.4127 16.6663 1.6665 15.9201 1.6665 14.9997V11.6663Z"
        stroke="black"
        strokeWidth="3"
        mask="url(#path-1-inside-1_1348_20594)"
      />
      <path
        d="M7.49984 8.33301C7.49984 7.41253 8.24603 6.66634 9.1665 6.66634H10.8332C11.7536 6.66634 12.4998 7.41253 12.4998 8.33301V14.9997C12.4998 15.9201 11.7536 16.6663 10.8332 16.6663H9.1665C8.24603 16.6663 7.49984 15.9201 7.49984 14.9997V8.33301Z"
        stroke="black"
        strokeWidth="3"
        mask="url(#path-1-inside-1_1348_20594)"
      />
      <path
        d="M13.3332 4.99967C13.3332 4.0792 14.0794 3.33301 14.9998 3.33301H16.6665C17.587 3.33301 18.3332 4.0792 18.3332 4.99967V14.9997C18.3332 15.9201 17.587 16.6663 16.6665 16.6663H14.9998C14.0794 16.6663 13.3332 15.9201 13.3332 14.9997V4.99967Z"
        stroke="black"
        strokeWidth="3"
        mask="url(#path-1-inside-1_1348_20594)"
      />
    </mask>
    <g mask="url(#mask0_1348_20594)">
      <rect width="20" height="20" fill={color} />
    </g>
  </Icon>
);
DifficultyMedium.displayName = 'DifficultyMedium';

export default DifficultyMedium;
